import React, { useState, useEffect } from "react";

export default function Publisher({
  publishers,
  checkedPublishers,
  setCheckedPublishers,
}) {
  const [searchFiltersQuery, setSearchFiltersQuery] = useState("");
  const [filteredPublishers, setFilteredPublishers] = useState(publishers);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  function handleFilter(e) {
    setSearchFiltersQuery(e.target.value);
  }

  const handleCheckbox = (obj) => {
    const isChecked = checkedPublishers.find((p) => p.id === obj.id);
    if (!isChecked) {
      setCheckedPublishers([obj, ...checkedPublishers]);
    } else {
      setCheckedPublishers(checkedPublishers.filter((p) => p.id !== obj.id));
    }
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const newCheckedPublishers = checked
      ? publishers.map((publisher) => ({
          id: publisher.id,
          name: publisher.name,
        }))
      : [];
    setCheckedPublishers(newCheckedPublishers);
    setSelectAllChecked(checked);
  };

  useEffect(() => {
    setFilteredPublishers(
      publishers.filter((p) =>
        p.name.toLowerCase().includes(searchFiltersQuery.toLowerCase())
      )
    );

    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const numChecked = checkedPublishers.length;
    setSelectAllChecked(numChecked === publishers.length);

    checkboxes.forEach((checkbox) => {
      const isChecked = checkedPublishers.find((p) => p.name === checkbox.name);
      checkbox.checked = !!isChecked;
    });
  }, [publishers, checkedPublishers, searchFiltersQuery]);

  return publishers ? (
    <div className="content-container">
      <div className="pub-check">
        <div className="select-all">
          <input
            type="checkbox"
            checked={selectAllChecked}
            onChange={handleSelectAll}
          />
          {selectAllChecked ? (
            <label>Uncheck all</label>
          ) : (
            <label>Check all</label>
          )}
        </div>
        <div className="searchbar">
          <input
            type="search"
            placeholder=" Search publishers"
            value={searchFiltersQuery}
            onChange={(e) => {
              handleFilter(e);
            }}
          />
        </div>

        <ul>
          {filteredPublishers.map((prop) => {
            return (
              <li key={prop.id}>
                <span
                  onClick={() => {
                    handleCheckbox({ id: prop.id, name: prop.name });
                  }}
                >
                  <input
                    checked={checkedPublishers.find((p) => p.id === prop.id)}
                    type="checkbox"
                    onChange={() => {
                      handleCheckbox({ id: prop.id, name: prop.name });
                    }}
                    name={prop.name}
                    key={prop.id}
                  ></input>
                  <label>{prop.name}</label>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  ) : null;
}
